
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class EqifyMenuDropdownItem extends Vue {
  @Prop({default: false}) dropLeft?: boolean
  @Prop({default: false}) dropRight?: boolean
  @Prop({default: false}) dropUp?: boolean
}
